import { Reveal, Overline } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How does online coaching work?",
    a: "Online coaching is fully remote and available worldwide. You get a customized workout and nutrition plan, weekly check-ins, adjustments, and messaging support — all managed through your phone. Perfect if you want expert guidance and accountability on your own schedule.",
  },
  {
    q: "How does in-person training work?",
    a: "In-person one-on-one training takes place at my designated training gym in the Savannah, Georgia area, by appointment only. Every session is tailored to your goals with hands-on form correction, programming, and accountability. A valid membership to the training gym is required before starting.",
  },
  {
    q: "Do you create custom nutrition plans?",
    a: "Yes. Nutrition guidance includes personalized calorie and macro targets, meal templates, a grocery guide, and snack recommendations. Ongoing coaching clients also get nutrition adjustments as they progress.",
  },
  {
    q: "Is a gym membership required?",
    a: "For in-person training, yes — you must obtain and maintain your own membership to the gym where sessions are held. For online coaching, no membership is required; I build gym OR home versions of your program based on your equipment.",
  },
  {
    q: "What are check-ins and how often are they?",
    a: "Ongoing coaching clients submit a weekly check-in (weight, progress photos, sleep, energy, hunger, workout and cardio completion, plus any questions). I review it and adjust your plan so you keep progressing.",
  },
  {
    q: "How is scheduling handled?",
    a: "In-person sessions are booked in advance based on availability. Online coaching runs on a weekly cadence with check-ins and messaging support throughout your enrollment.",
  },
  {
    q: "How do payments work?",
    a: "Every client starts with an application — no payment upfront. After I review it and confirm the right program for you, I'll walk you through secure payment and next steps directly.",
  },
  {
    q: "What is your refund policy?",
    a: "Custom digital products (workout programs, nutrition blueprints) are non-refundable once delivered, since they're built specifically for you. Monthly coaching can be discontinued after the minimum commitment; prorated refunds for partial periods are not provided.",
  },
  {
    q: "What is your cancellation policy?",
    a: "In-person sessions require at least 24 hours' notice to cancel or reschedule. Missed sessions without notice are forfeited, and arriving 15+ minutes late may shorten or forfeit the session.",
  },
  {
    q: "Are beginners welcome?",
    a: "Absolutely. Every program is built for Beginner, Intermediate, and Advanced levels. Wherever you're starting from, I'll meet you there and guide you every step of the way.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-[#141414]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <Overline>Frequently Asked</Overline>
          <h2 className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
            Questions & Answers
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 w-full space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-[#0A0A0A] border border-[#262626] px-6"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-semibold text-white text-base sm:text-lg hover:text-[#0055FF] hover:no-underline py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A3A3A3] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
